import type { AddressFieldsFragment } from "~graphql/generated/graphql"

export function formatCityStateAndCountry(
    location?: AddressFieldsFragment | null
) {
    if (!location) return null

    return `${location.city}, ${location.state}, ${location.country}`
}

export function formatEnumToTitleCase(enumValue?: string) {
    if (!enumValue) return ""

    return enumValue
        .split("_")
        .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ")
}
